/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

const locationSearchwNodes = Array.from(document.querySelectorAll('.location-search'));
if (locationSearchwNodes.length) {
    import(/* webpackChunkName: "LocationSearch" */ './components/LocationSearch').then(({ default: LocationSearch }) => {
        locationSearchwNodes.forEach((node) => {
            const root = createRoot(node);
            root.render(<LocationSearch {...(JSON.parse(node.dataset.locationSearch || '{}'))} />);
        });
    });
}
